/**
 * @file
 * @copyright  2017 Subscribe-HR
 */

import Integer from './Integer';

/**
 * Subscribe-HR entity text field
 */
export default class Key extends Integer {
}



// WEBPACK FOOTER //
// ./src/client/common/js-subscribe-sdk/lib/Fields/Key.js